<template>
  <div class="justify-content-center w-100">
        <b-container fluid class="max-width py-4">
            <h4 class="text-primary">{{trans('legend.privacy_options')}}</h4>
            <hr />

            <div class="row justify-content-center">
                <div class="col-md-10">
                    <h5 class="text-primary mt-5 mb-4">{{trans('legend.visibility_of_content')}}</h5>

                    <div class="row">
                        <div class="col-md-2 d-flex align-items-center">
                            <privacy-alert buttonSize="sm">
                                <img src="/images/icon_private.svg" width="24px" class="pr-1" /> {{trans('legend.only_you')}}
                            </privacy-alert>
                        </div>
                        <div class="col-md-10">
                            {{trans('legend.only_you_content')}}
                        </div>
                    </div>
                    <hr />
                    <div class="row">
                        <div class="col-md-2 d-flex align-items-center">
                            <privacy-alert buttonSize="sm">
                                <img src="/images/icon_company.svg" width="24px" class="pr-1" /> {{company.name}}
                            </privacy-alert>
                        </div>
                        <div class="col-md-10">
                           {{trans('legend.company_content', {company: company.name})}}
                        </div>
                    </div>
                    <hr />
                    <div class="row pb-5">
                        <div class="col-md-2 d-flex align-items-center">
                            <privacy-alert buttonSize="sm">
                                <img src="/images/icon_public.svg" width="24px" class="pr-1" /> {{trans('global.lifeed')}}
                            </privacy-alert>
                        </div>
                        <div class="col-md-10">
                           {{trans('legend.lifeed_content')}}
                        </div>
                    </div>

                    <h5 class="text-primary mt-5 mb-4">{{trans('legend.moderation')}}</h5>

                    <div class="row pb-5">
                        <div class="col-md-2 d-flex align-items-center">
                            <privacy-alert buttonSize="sm">
                                <img src="/images/moderation.svg" height="21px" />
                            </privacy-alert>
                        </div>
                        <div class="col-md-10">
                           {{trans('legend.moderation_content_1', {company: company.name})}}<br />
                           {{trans('legend.moderation_content_2', {company: company.name})}}<br />
                        </div>
                    </div>

                    <div class="d-flex justify-content-end mt-5 mb-5">
                        <b-button variant="secondary" target="_blank" :href="trans('community.privacy_link')">
                            privacy policy
                        </b-button>
                    </div>
                </div>
            </div>

        </b-container>
    </div>
</template>

<script>
    import PrivacyAlert from "../molecules/PrivacyAlert"
    import { mapGetters } from 'vuex';

    export default {
        name: "PrivacyLegend",
        components: {
            PrivacyAlert
        },
        computed: {
            ...mapGetters({
                company: 'user/getCompanyInfo'
            })
        },
    }
</script>

